import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './index.css'
import moshaToast from 'mosha-vue-toastify'
import 'mosha-vue-toastify/dist/style.css'
import vueScrollTo from 'vue-scrollto'
import VueGtag from 'vue-gtag'
import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { fal } from '@fortawesome/pro-light-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import environmentProd from './config/prod.env.js';
import environmentStage from './config/stage.env.js';
import environmentUat from './config/uat.env.js';

import * as microsoftTeams from "@microsoft/teams-js";

// Initialize Microsoft Teams SDK globally
microsoftTeams.initialize();

library.add(fas, fal, far, fab)
dom.watch();

//Add all icons to the library so you can use it in your page
const app = createApp(App);
const baseUrl = window.location.origin;

// Check if the base URL contains "uat" or "stage"
if (baseUrl.includes("uat") ) {
        var environmentConfig = environmentUat;
} else if (baseUrl.includes("stage") || (baseUrl.includes("local") )) {
        environmentConfig = environmentStage;
} else {
        environmentConfig = environmentProd;
}

app.config.globalProperties.baseAPIURL = environmentConfig.VUE_APP_API;
app.config.globalProperties.theme_url = environmentConfig.VUE_THEME_URL;
app.config.globalProperties.app_environment = environmentConfig.VUE_APP_ENVIRONMENT;
app.config.globalProperties.uber_api = environmentConfig.VUE_APP_UBERAPI;
app.config.globalProperties.gmaps = environmentConfig.VUE_APP_MAPS;
app.config.globalProperties.google_client_id = environmentConfig.VUE_APP_GOOGLE_CLIENT_ID;
app.config.globalProperties.apple_bundle_id = environmentConfig.VUE_APP_APPLE_BUNDLE_ID;
app.config.globalProperties.azure_client_id = environmentConfig.VUE_APP_AZURE_CLIENT_ID;
app.config.globalProperties.azure_tenant_id = environmentConfig.VUE_APP_AZURE_TENANT_ID;
app.config.globalProperties.dify_semantic_search = environmentConfig.VUE_DIFY_SEMANTIC_SEARCH;
app.config.globalProperties.dify_search_validator = environmentConfig.VUE_DIFY_SEARCH_VALIDATOR;
app.config.globalProperties.app_environment = environmentConfig.VUE_APP_ENVIRONMENT;

app.config.globalProperties.appVersion = '3.7.6';

app
.use(store)
.use(moshaToast)
.use(vueScrollTo)
// .component("font-awesome-icon", FontAwesomeIcon)
.use(router).use(VueGtag, {
        appName: 'Tap 3',
        pageTrackerScreenviewEnabled: true,
        config: { id: "G-K0G0SZKBDZ" }
}, router)
.mount('#app')